module.exports = __webpack_public_path__ + "static/img/bus-top.65000b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bus-top.jpg
// module id = IBpA
// module chunks = 0